import React, { useEffect, useState } from 'react';
import { AutoTypeText } from 'SharedComponents/styled/forms/AutoTypeText';

const AutoType: React.FunctionComponent<{ animDelay?: number; replayDelay?: number; children: string }> = ({
    animDelay = 125,
    replayDelay = 6000,
    children,
}) => {
    const [text, setText] = useState('');
    const [pointer, setPointer] = useState(-1);

    useEffect(() => {
        let intervalId: ReturnType<typeof setTimeout>;

        if (pointer < children.length) {
            intervalId = setTimeout(() => {
                setText(text + children.charAt(pointer));
                setPointer(pointer + 1);
            }, animDelay);
        } else {
            intervalId = setTimeout(() => {
                setText('');
                setPointer(-1);
            }, replayDelay);
        }

        return () => clearInterval(intervalId);
    }, [pointer, children, animDelay, text, replayDelay]);

    return <AutoTypeText data-testid="email-auto-type">{text}</AutoTypeText>;
};

export default AutoType;
